import {Anchor, Box, Container, Flex, Group} from "@mantine/core";
import React from "react";
// Keeping social media icon imports for future use
import { IconBrandInstagram, IconBrandFacebook, IconBrandTiktok, IconBrandYoutube } from "@tabler/icons-react";

// todo: modify footer to include these social links in the future!
// Social media URLs for future use
const socialLinks = [
    {link: "https://instagram.com/sortmyshoebox", label: "Instagram"},
    {link: "https://facebook.com/sortmyshoebox", label: "Facebook"},
    {link: "https://tiktok.com/@sortmyshoebox", label: "TikTok"},
    {link: "https://youtube.com/@sortmyshoebox", label: "YouTube"},
]

const footerLinks = [
    { link: 'https://dev.sortmyshoebox.com/privacy-policy', label: 'Privacy Policy' },
    { link: 'https://sortmyshoebox.com/terms-and-conditions', label: 'Terms & Conditions' },
    { link: 'https://www.iubenda.com/privacy-policy/28756182/cookie-policy', label: 'Cookies' },
    { link: '/blog', label: 'Blog'},
    { link: '/blog/photo-scanning-guide', label: 'Photo Scanning Guide'},
    { link: '/faq', label: 'FAQ'},
];

export function Footer() {
    const items = footerLinks.map((link) => (
        <Anchor<'a'>
            c="dimmed"
            key={link.label}
            href={link.link}
            size="sm"
        >
            {link.label}
        </Anchor>
    ));

    return (
        <Box w="100%" bg="#f5f5f5" px={40} pb={20} pt="md"> {/* Grey background for footer */}
            <Container fluid>
                <Flex justify="space-between" align="center">
                    <img src="/logo.png" alt="Company Logo" style={{width: 52}}/>
                    <Group>{items}</Group>
                </Flex>
            </Container>
        </Box>
    );
}